import { render, staticRenderFns } from "./WisdomDataRule.vue?vue&type=template&id=33bd4be9"
import script from "./WisdomDataRule.vue?vue&type=script&lang=js"
export * from "./WisdomDataRule.vue?vue&type=script&lang=js"
import style0 from "./WisdomDataRule.vue?vue&type=style&index=0&id=33bd4be9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports